import { UseQueryResult } from '@tanstack/react-query';
import React from 'react';
import { Skeleton } from 'ui';

// Renders `children(data)` once the query has resolved, showing `fallback`
// (or a default skeleton) while loading / on error. Shared across apps so the
// performance dashboard can live in one place.
export function WaitForQuery<T extends UseQueryResult>({
  query,
  fallback,
  children,
}: {
  query: T;
  fallback?: React.ReactNode;
  children: React.FC<Extract<T, { isSuccess: true }>['data']>;
}) {
  if (query.isLoading || query.error || !query.data) {
    return (
      fallback ?? (
        <div className='space-y-2'>
          <Skeleton className='h-4 w-[250px]' />
          <Skeleton className='h-4 w-[200px]' />
        </div>
      )
    );
  }

  return children(query.data);
}
